import React__default from 'react';

var DefaultEmptyImg = function DefaultEmptyImg() {
  return /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    version: "1.1"
  }, /*#__PURE__*/React__default.createElement("defs", null, /*#__PURE__*/React__default.createElement("rect", {
    id: "path-1",
    x: "0",
    y: "0",
    width: "64",
    height: "42.5931034"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    id: "path-3",
    cx: "31.8632479",
    cy: "31.6057105",
    rx: "31.8632479",
    ry: "31.6057105"
  })), /*#__PURE__*/React__default.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(-480, -696)"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(480, 706)"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React__default.createElement("g", null), /*#__PURE__*/React__default.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(0, 1.6278)"
  }, /*#__PURE__*/React__default.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React__default.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React__default.createElement("use", {
    stroke: "none",
    fill: "#D9E2EB",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    stroke: "none",
    fill: "#ECF1F5",
    fillRule: "evenodd",
    mask: "url(#mask-4)",
    cx: "16.1367521",
    cy: "29.2997145",
    rx: "9.84615385",
    ry: "9.76657149"
  }))), /*#__PURE__*/React__default.createElement("ellipse", {
    fill: "#ECF1F5",
    mask: "url(#mask-2)",
    cx: "56.6153846",
    cy: "12.2082144",
    rx: "5.74358974",
    ry: "5.6971667"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    fill: "#ECF1F5",
    mask: "url(#mask-2)",
    cx: "53.7435897",
    cy: "25.0946629",
    rx: "2.87179487",
    ry: "2.84858335"
  }), /*#__PURE__*/React__default.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React__default.createElement("g", {
    transform: "translate(37.5275, 29.5924) rotate(-45) translate(-37.5275, -29.5924)translate(22.7583, 6.3864)"
  }, /*#__PURE__*/React__default.createElement("rect", {
    fill: "#FF7D41",
    fillRule: "evenodd",
    x: "11.9976068",
    y: "27.0109757",
    width: "5.37062937",
    height: "19.4010471",
    rx: "2.68531469"
  }), /*#__PURE__*/React__default.createElement("rect", {
    fill: "#FFC610",
    fillRule: "evenodd",
    x: "11.9976068",
    y: "27.1015714",
    width: "5.37062937",
    height: "4.61996059",
    rx: "2.30998029"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    fill: "#FF962F",
    fillRule: "evenodd",
    cx: "14.7692308",
    cy: "14.7109271",
    rx: "14.7692308",
    ry: "14.7109271"
  }), /*#__PURE__*/React__default.createElement("ellipse", {
    fill: "#FFEEE5",
    fillRule: "evenodd",
    cx: "14.7692308",
    cy: "14.7109271",
    rx: "10.8633185",
    ry: "10.820434"
  }), /*#__PURE__*/React__default.createElement("path", {
    d: "M14.7692308,3.28076761 C21.1050793,3.28076761 26.2422748,8.39768327 26.2422748,14.7109271 C26.2422748,21.024171 21.1050793,26.1410866 14.7692308,26.1410866 C8.43338223,26.1410866 3.29618676,21.024171 3.29618676,14.7109271 C3.29618676,8.39768327 8.43338223,3.28076761 14.7692308,3.28076761 Z M14.7692308,4.50021864 C9.10578903,4.50021864 4.51563778,9.07224961 4.51563778,14.7109271 C4.51563778,20.3496046 9.10578903,24.9216356 14.7692308,24.9216356 C20.4326725,24.9216356 25.0228238,20.3496046 25.0228238,14.7109271 C25.0228238,9.07224961 20.4326725,4.50021864 14.7692308,4.50021864 Z",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React__default.createElement("ellipse", {
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    cx: "35.020979",
    cy: "18.8435458",
    rx: "2.12587413",
    ry: "2.11850515"
  })))));
};

export { DefaultEmptyImg as default };
